module.exports = __webpack_public_path__ + "static/media/PRO_DECK_SWITCH_PERFORMANCE.2cec33c5.mp4";